/* ABS: recuperar comportamiento móvil original de la cabecera (ocultar al bajar, mostrar al subir). */
(() => {
  if (window.__absMobileHeaderScroll) return;
  window.__absMobileHeaderScroll = true;
  const mobile = window.matchMedia('(max-width: 989px)');
  let lastY = window.scrollY || 0;
  let raf = 0;
  const update = () => {
    raf = 0;
    const header = document.querySelector('.section-header');
    if (!header || !mobile.matches) { lastY = window.scrollY || 0; return; }
    const y = window.scrollY || document.documentElement.scrollTop || 0;
    const delta = y - lastY;
    const menuOpen = !!header.querySelector('#Details-menu-drawer-container[open]');
    const searchOpen = !!header.querySelector('details-modal[open]');
    if (menuOpen || searchOpen) {
      header.classList.remove('shopify-section-header-hidden');
    } else if (y <= 12) {
      header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    } else if (delta > 3 && y > Math.max(header.offsetHeight, 90)) {
      header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      header.classList.remove('animate');
    } else if (delta < -3) {
      header.classList.remove('shopify-section-header-hidden');
      header.classList.add('shopify-section-header-sticky', 'animate');
    }
    lastY = y;
  };
  window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(update); }, {passive:true});
  window.addEventListener('resize', () => { lastY = window.scrollY || 0; update(); }, {passive:true});
  window.addEventListener('load', update, {once:true});
})();
